export class MsalAuthProvider {
  constructor(msalInstance, loginRequest = {}) {
    this.msalInstance = msalInstance;
    this.loginRequest = loginRequest;
  }

  async getAccessToken() {
    const account = this.msalInstance.getActiveAccount();

    if (!account) {
      throw new Error("No account currently active, user is not signed in.");
    }

    try {
      const response = await this.msalInstance.acquireTokenSilent({
        ...this.loginRequest,
        account: account,
      });

      return response.accessToken;
    } catch (error) {
      console.error("Silent token acquisition failed. Attempting popup:", error);
      const response = await this.msalInstance.acquireTokenPopup({
        ...this.loginRequest,
        account: account,
      });
      return response.accessToken;
    }
  }
}